export function exportWorkOrderEndpoint(workOrderId: number): string {
  return `/work-orders/${workOrderId}/export/`;
}
